import React from 'react';
import { Switch, FormControlLabel } from '@mui/material';
import { alpha, styled } from '@mui/material/styles';
import { GREEN_PRIMARY, GREEN_SECONDARY, BABY_BLUE_PRIMARY, BABY_BLUE_SECONDARY } from "../../colors";
var PREFIX = 'BrandSwitch';
var classes = {
  formControl: "".concat(PREFIX, "-formControl"),
  switchTrack: "".concat(PREFIX, "-switchTrack")
};
var StyledFormControlLabel = styled(FormControlLabel)(function () {
  return {
    height: '20px'
  };
});
var StyledSwitch = styled(Switch)(function (_ref) {
  var theme = _ref.theme;
  return {
    '& .MuiSwitch-switchBase.Mui-checked > span': {
      color: GREEN_PRIMARY,
      '&:hover': {
        backgroundColor: alpha(GREEN_SECONDARY, theme.palette.action.hoverOpacity)
      }
    },
    '& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track': {
      backgroundColor: GREEN_SECONDARY,
      opacity: 1
    },
    '& .MuiSwitch-switchBase > span': {
      color: BABY_BLUE_PRIMARY,
      '&:hover': {
        backgroundColor: alpha(BABY_BLUE_SECONDARY, theme.palette.action.hoverOpacity)
      }
    },
    '& .MuiSwitch-switchBase + .MuiSwitch-track': {
      backgroundColor: BABY_BLUE_SECONDARY,
      opacity: 1
    }
  };
});
var BrandSwitch = function BrandSwitch(_ref2) {
  var checked = _ref2.checked,
    onChange = _ref2.onChange,
    ariaLabel = _ref2.ariaLabel,
    label = _ref2.label;
  return /*#__PURE__*/React.createElement(StyledFormControlLabel, {
    sx: {
      margin: 0
    },
    className: classes.formControl,
    label: label,
    control: /*#__PURE__*/React.createElement(StyledSwitch, {
      classes: {
        track: classes.switchTrack
      },
      checked: checked,
      onChange: onChange,
      inputProps: {
        'aria-label': ariaLabel
      }
    })
  });
};
export default BrandSwitch;